import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import usePrequal from '../../resources/prequal/usePrequal';
import useSignDocument from '../../resources/documents/sign';
import useCapsUser from '../../resources/capsUsers/read';

const useForm = () => {
  const { data: prequal } = usePrequal();
  const { data: capsUser } = useCapsUser();
  const documentId = capsUser.relationships.cardholder_agreement.data.id;

  const onSuccess = () => {
    if (window.opener) {
      window.opener.postMessage('SIGNED', '*');
    } else if (capsUser.attributes.servicing_platform === 'PEACH') {
      window.location.replace(`/${process.env.PREFIX}/borrower`);
    } else {
      window.location.replace(`/${process.env.PREFIX}/customers/${prequal.capsId}`);
    }
  };

  return useSWRMutationForm({
    useMutation: () => useSignDocument(documentId, { onSuccess }),
    useUnhandledError: useErrorToSnackbar,
  });
};

export default useForm;
